export default __webpack_public_path__ + "static/media/ad_1.e25011fc.mp3";